import { useTranslation } from "react-i18next";
import type { GoogleCredentialResponse } from "@medplum/core";

import { GOOGLE_CLIENT_ID } from "@/constants/app.constants";
import { cn } from "@/lib/utils";

import { GoogleButton } from "@/components/module/GoogleButton";

type Props = {
  onCredential: (response: GoogleCredentialResponse) => void | Promise<void>;
  className?: string;
};

export const GoogleSignInSection: React.FC<Props> = ({
  onCredential,
  className,
}) => {
  const { t } = useTranslation();

  if (!GOOGLE_CLIENT_ID) {
    return null;
  }

  return (
    <div className={cn("flex flex-col gap-5", className)}>
      <GoogleButton
        googleClientId={GOOGLE_CLIENT_ID}
        onCredential={onCredential}
      />
      <div className="text-muted-foreground flex items-center gap-2 text-sm">
        <div className="bg-border h-px flex-1" />
        <span>{t("or")}</span>
        <div className="bg-border h-px flex-1" />
      </div>
    </div>
  );
};
